import type { IParagraphEntry } from "~/models/IUserEntry";

export function useHelperText(
  markingMode: Ref<string | undefined>,
  moving: Ref<IParagraphEntry | undefined>
) {
  const { t } = useI18n();

  const addTexts: Record<
    IParagraphEntry["type"] | "erasing",
    string | ComputedRef
  > = {
    schema: computed(() => t("legal_text.textEditor.helper_texts.schema")),
    note: computed(() => t("legal_text.textEditor.helper_texts.note")),
    link_chain: computed(() =>
      t("legal_text.textEditor.helper_texts.link_chain")
    ),
    underline: computed(() =>
      t("legal_text.textEditor.helper_texts.underline")
    ),
    mark: computed(() => t("legal_text.textEditor.helper_texts.mark")),
    erasing: computed(() => t("legal_text.textEditor.helper_texts.eraser")),
  };

  const helperText = computed(() => {
    if (!markingMode.value) {
      return "";
    }
    return moving.value
      ? t("legal_text.textEditor.helper_texts.move")
      : addTexts[markingMode.value];
  });

  return { helperText };
}
